import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    pointTitle: 'heading-2xl leading-[29px]',
    pointPrefix: 'capitalize',
    pointAddress: 'heading-s mt-2',
    pointCost: 'heading-s mt-2',
    pointDeliveryDate: 'heading-s mt-1',
    pointHeading: 'heading-s mt-3',
    pointValue: 'heading-s mt-2',
    pointConfirm: 'mt-5 w-full'
  }
});
